import type { SidebarItem } from '../components/Sidebar'

// Workspace section = PEXIFY's own Tasks list. The Focalboard / Leantime
// embeds were removed on 2026-10-22 when those tools were retired.
export type WorkspaceTasksEntry = { label: string; badge: number }

// Tasks is PEXIFY's own to-do list (migration 346) — live on every shell.
export const workspaceTasksItem = (
  shellPrefix: '/admin' | '/seller' | '/supply',
  tasks: WorkspaceTasksEntry,
): SidebarItem => ({
  to: `${shellPrefix}/workspace/tasks`,
  label: tasks.label,
  icon: 'taskComplete',
  badge: tasks.badge,
})

export const workspaceSidebarItems = (
  shellPrefix: '/admin' | '/seller' | '/supply',
  tasks: WorkspaceTasksEntry,
): SidebarItem[] => {
  return [
    { to: `${shellPrefix}/workspace-header`, label: 'Workspace', isHeader: true },
    workspaceTasksItem(shellPrefix, tasks),
    // Supademo (interactive product demos) left the nav on 2026-10-05: the
    // workspace holds no demos yet. It returns under Settings → Help once
    // demos are produced; the URL constant stays for that.
  ]
}
